const ACCESS_LINK_TOKEN_HEADER_NAME = "X-Access-Link-Token";

export {ACCESS_LINK_TOKEN_HEADER_NAME}
